import React from "react";
import feedback from "../../../resources/feedback/school feedback";
import CarouselRow from "../../common/CarouselRow";
import ImageCard from "../../common/ImageCard";
import { useGetMediaQuery } from "../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";

const Feedback = () => {
    const { isMobile } = useGetMediaQuery();
    const { t } = useTranslation("home");

    const gallery = feedback.map((fb, index) => (
        // TODO: get children content for each certificate.
        <ImageCard src={fb} key={index} children={index} />
    ));

    return (
        <div className="bg-gray-100 py-8 text-center space-y-4">
            <div className="text-2xl text-emerald-400 font-bold">
                {t("feedback.title")}
            </div>
            <div className="text-lg">
                {t("feedback.subtitle")}
            </div>

            <CarouselRow children={gallery} />
        </div>
    );
};

export default Feedback;
